<script>
import Layout from '@layouts/main';
import NewsForm from '@views/news/form';

export default {
  components: {
    Layout,
    NewsForm,
  },
  page() {
    return {
      title: this.$t('titles.create_news'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.news'),
          to: { name: 'news.index' },
        },
        {
          text: this.$t('titles.create_news'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'news.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_news')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <NewsForm @submitted="create" />
    </b-card>
  </Layout>
</template>
